import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { AffinityStatus } from "../../recommendation.types";

export const requestGetAffinityStatus = async (): Promise<AffinityStatus> => {
  return await instance.get(ApiRoutesRecommendation.AffinityStatus);
};
